import '../License.scss'
import { useEffect, useState } from 'react'
import LicenseService from '../../../services/license.service'

export function RenewLicenseRequestList() {
  const [requests, setRequests] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const loadData = async () => {
      try {
        setIsLoading(true)
        const requests = await LicenseService.listAll()
        setRequests(requests)
      } catch (error) {
        return <p>Ocorreu um erro!</p>
      } finally {
        setIsLoading(false)
      }
    }
    loadData()
  }, [])

  if (isLoading) {
    return <p>Carregando...</p>
  }

  if (requests.length === 0) {
    return <p>Sem solicitações</p>
  }

  return (
    <ul className='renew-license-requests-list'>
      {requests.map((request) => (
        <li className='renew-license-requests-list-item box-card'>
          <div className='renew-license-requests-list-item-text'>
            <i class='far fa-user' />
            <p>{request.instructorId.name}</p>
          </div>
          <div className='renew-license-requests-list-item-text'>
            <i class='far fa-envelope' />
            <span>{request.instructorId.email}</span>
          </div>
          <div className='renew-license-requests-list-item-text'>
            <i class='far fa-building' />
            <span>{request.instructorId.institution.name}</span>
          </div>
          <div className='renew-license-requests-list-item-text'>
            <i class='far fa-calendar-alt' />
            <span>
              Solicitado em{' '}
              {new Date(request.requestDate).toLocaleDateString('pt-BR')}
            </span>
          </div>
        </li>
      ))}
    </ul>
  )
}
